import "./Profile.css"

import {MostPopular} from "../../sections/index"

const Profile = () => {
  return (
        <>
            
            <MostPopular/>
        </>
  )
}

export default Profile